import { ObservableSet } from "mobx";
import { observer } from "mobx-react-lite";

import { IDetailsRowProps, Stack, useTheme } from "@bps/fluent-ui";
import {
  XeroFinancialSyncOperation,
  XeroFinancialSyncSource
} from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";

export interface XeroFinancialSyncOperationListItem
  extends XeroFinancialSyncOperation {
  index: number;
  hasChildren: boolean;
}

interface XeroSyncHistoryListRowProps {
  defaultRender: (props: IDetailsRowProps) => JSX.Element | null;
  props: IDetailsRowProps;
  openRows: ObservableSet;
}

export const XeroSyncHistoryListRow = observer(
  ({ defaultRender, props, openRows }: XeroSyncHistoryListRowProps) => {
    const theme = useTheme();
    const data = props.item as XeroFinancialSyncSource;

    const isOpen = openRows.has(data.operations[0].id);

    return (
      <Stack>
        {data.operations.map((operation, index) => {
          if (!isOpen && index > 0) return;

          const item: XeroFinancialSyncOperationListItem = {
            ...operation,
            index,
            hasChildren: index === 0 && data.operations.length > 1
          };

          return defaultRender({
            ...props,
            item,
            styles: {
              root: {
                backgroundColor:
                  index !== 0 ? theme.palette.neutralLighterAlt : undefined,
                borderBottom:
                  index !== data.operations.length - 1 ? "none" : undefined
              }
            }
          });
        })}
      </Stack>
    );
  }
);
